import { Selection, type Node, type NodeGroup } from './types';
import type { TreeState } from './useTreeState';

export const filterNode = (node: Node, matcher: string): { node: Node; hasMatch: boolean } => {
    const hasMatch = Boolean(node.name?.toLowerCase().includes(matcher));

    return node.children.reduce(
        (acc, group) => {
            acc.node.children.push({
                ...group,
                nodes: group.nodes.reduce((nodes, node) => {
                    const { hasMatch: matched, node: filtered } = filterNode(node, matcher);

                    acc.hasMatch ||= matched;
                    if (matched) {
                        nodes.push(filtered);
                    }

                    return nodes;
                }, [] as Node[]),
            });

            return acc;
        },
        {
            node: {
                ...node,
                children: [] as NodeGroup[],
            },
            hasMatch,
        }
    );
};

export const filterNodes = (nodes: Node[], matcher: string): Node[] => {
    const sanitized = matcher.trim().toLowerCase();
    if (!sanitized) return nodes;

    return nodes
        .map((node) => filterNode(node, sanitized))
        .reduce((acc, curr) => {
            if (curr.hasMatch) acc.push(curr.node);
            return acc;
        }, [] as Node[]);
};

export const getTreeState = (node: Node, init?: TreeState): TreeState => {
    return node.children.reduce(
        (state, group) => {
            if (!group.nodes.length) return state;
            state.groups.push(group.type);
            state.type = group.nodesType;

            return getTreeState(group.nodes[0], state);
        },
        {
            [Selection.Company]: null,
            [Selection.Reseller]: null,
            [Selection.Location]: null,
            type: null,
            groups: [],
            ...init,
            [node.type]: node.id,
        } as TreeState
    );
};
